import { PaintedScene } from '../PaintedScene';

export const ASHVEIN_FORGE_INTERIOR_PHASER_KEY = 'AshveinForgeInteriorScene' as const;
export const ASHVEIN_FORGE_INTERIOR_MANIFEST_KEY = 's-409-ashvein-forge-interior' as const;

export class AshveinForgeInteriorScene extends PaintedScene {
  constructor() {
    super(ASHVEIN_FORGE_INTERIOR_PHASER_KEY, ASHVEIN_FORGE_INTERIOR_MANIFEST_KEY);
  }
}
